import React, { useEffect, useState } from 'react';
import { LayoutCharts } from './layout/LayoutCharts';
import LoadingOverlay from '../../components/others/LoadingOverlay';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { loadDataLogin } from '../../redux/actions/auth';
import { useDispatch } from 'react-redux';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;

export const ChartsScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token, id } = useParams();
    const [isAuthorized, setIsAuthorized] = useState(null);
    const [conf, setconf] = useState(null);

    useEffect(() => {
        if (!token || !id) {
            setIsAuthorized(false);
            return;
        }

        const getMenuId = async () => {
            console.log('obj ==> ', { token, id });
            try {
                let config = {
                    method: 'POST',
                    url: baseUrl,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    data: JSON.stringify({
                        'process': 'user_select',
                        'action': 'MENU_ID',
                        'variables': JSON.stringify({ id_user_action: id })
                    })
                };

                const response = await axios.request(config);
                if (response.status === 200) {
                    const userExternalData = {
                        "session": {
                            token: token
                        },
                        username: 'External user',
                    }
                    let item = response.data[0];
                    dispatch(loadDataLogin(userExternalData));
                    setconf(item);
                    setIsAuthorized(true);
                }
            } catch (err) {
                console.error('Error:', err);
                setIsAuthorized(false);
            }
        };
        getMenuId();
    }, [token, id, navigate, dispatch]);

    if (isAuthorized === null) {
        return <LoadingOverlay
            isOpen={true}
            text={'Cargando...'}
        />
    }

    if (isAuthorized === false) {
        return <div>No autorizado</div>;
    }

    return <LayoutCharts
        conf={conf}
    />;
};
